import React, { Component } from "react";
import { Card } from "components/Card/Card.jsx";
import { Grid, Row, Col } from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import { importDatafile } from "../../redux/actions";

import { NotificationManager } from "react-notifications";

const mapStateToProps = (state) => {
  return {
    services: state.services,
    drivers: state.drivers,
    customers: state.customers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    importDatafile: (datafile) => dispatch(importDatafile(datafile)),
  };
};

class Backup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accept: "",
      files: [],
      dropzoneActive: false,
      cSTR: "",
      sSTR: "",
      dSTR: "",
      dataFile: "",
    };
    this.importInvoice = this.importInvoice.bind(this);
    this.importDataFile = this.importDataFile.bind(this);
  }

  importInvoice() {
    let { dataFile } = this.state;
    this.props.importDatafile(dataFile);
    NotificationManager.success("با موفقیت وارد شد", "انجام شد");
  }

  onDragEnter() {
    this.setState({
      dropzoneActive: true,
    });
  }

  onDragLeave() {
    this.setState({
      dropzoneActive: false,
    });
  }

  onDrop(files) {
    this.setState({
      files,
      dropzoneActive: false,
    });
  }

  applyMimeTypes(event) {
    this.setState({
      accept: event.target.value,
    });
  }

  importDataFile(accepted, rejected) {
    if (accepted.length > 0) {
      let file = accepted[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.setState({ dataFile: reader.result });
      };
      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.readAsDataURL(file);
    }
  }

  render() {
    let dropzoneRefDatafile;
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                id="invoice"
                title="وارد کردن فاکتور فروش"
                content={
                  <div>
                    <Row>
                      <Col xs={12}>
                        <div>
                          <div>
                            <Dropzone
                              ref={(node) => {
                                dropzoneRefDatafile = node;
                              }}
                              onDrop={this.importDataFile}
                            >
                              <p>فایل را به اینجا بکشید</p>
                            </Dropzone>
                          </div>
                          <div
                            style={{ marginTop: "10px", textAlign: "center" }}
                          >
                            <Button
                              bsStyle="info"
                              onClick={this.importInvoice}
                              pullRight
                              fill
                              type="button"
                            >
                              ثبت
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const BackupConnect = connect(mapStateToProps, mapDispatchToProps)(Backup);

export default BackupConnect;
